import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../services/api';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tokenReady, setTokenReady] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      console.log('[AuthContext] Iniciando loadUser...');
      try {
        // carrega token do localStorage
        const token = localStorage.getItem('userHash');
        const storedUser = localStorage.getItem('user');
        
        console.log('[AuthContext] Token encontrado:', !!token);
        console.log('[AuthContext] User encontrado:', !!storedUser);
        
        if (token && storedUser) {
          try {
            // Configura token no apiService
            await apiService.setAuthToken(token);
            setUser(JSON.parse(storedUser));
            setTokenReady(true);
            console.log('[AuthContext] Usuário autenticado:', JSON.parse(storedUser)?.nome);
          } catch (err) {
            console.error('[AuthContext] Erro ao configurar token:', err);
            // limpa dados inválidos
            localStorage.removeItem('userHash');
            localStorage.removeItem('user');
            setTokenReady(false);
          }
        } else {
          console.log('[AuthContext] Nenhum token encontrado');
          setTokenReady(false);
        }
      } catch (error) {
        console.error('[AuthContext] Erro ao carregar usuário:', error);
        setTokenReady(false);
      } finally {
        setLoading(false);
        console.log('[AuthContext] loading finalizado, tokenReady:', false);
      }
    };
    
    loadUser();
  }, []);

  const login = async (cpf, senha) => {
    console.log('[AuthContext] Tentando login...');
    try {
      const response = await apiService.login(cpf, senha);
      console.log('[AuthContext] Resposta do login:', response);
      
      if (response.sucesso && response.usuario) {
        // Salva dados do usuário
        localStorage.setItem('user', JSON.stringify(response.usuario));
        
        setUser(response.usuario);
        setTokenReady(true);
        
        console.log('[AuthContext] Login bem sucedido:', response.usuario.nome);
        
        // Dispara evento de autenticação
        window.dispatchEvent(new Event('auth:change'));
        
        return { success: true, user: response.usuario };
      }
      
      return { success: false, message: response.mensagem || 'Falha ao autenticar' };
    } catch (error) {
      console.error('[AuthContext] Erro no login:', error);
      return { success: false, message: 'Erro ao conectar com o servidor' };
    }
  };

  const logout = async () => {
    console.log('[AuthContext] Fazendo logout...');
    await apiService.clearAuthToken();
    localStorage.removeItem('user');
    localStorage.removeItem('userHash');
    setUser(null);
    setTokenReady(false);
    window.dispatchEvent(new Event('auth:change'));
  };

  return (
    <AuthContext.Provider value={{
      user,
      tokenReady,
      loading,
      isAuthenticated: !!user && tokenReady,
      login,
      logout,
      apiService,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};